import store from "@frameworks/web/redux/store";
import { ORDER_DETAILS_CLEAR_DATA, ORDER_DETAILS_DATA, ORDER_DETAILS_ERROR_DATA, ORDER_DETAILS_HIDE_ERROR_DATA, ORDER_DETAILS_START_LOADER, ORDER_DETAILS_STOP_LOADER, } from "../interface/IOrderDetails";
class OrderDetailsActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    orderDetails(orderDetails) {
        this.dispatch({
            type: ORDER_DETAILS_DATA,
            payload: { orderDetails },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: ORDER_DETAILS_ERROR_DATA,
            payload: { errorData: payload },
        });
    }
    clearData(errorType) {
        this.dispatch({
            type: ORDER_DETAILS_CLEAR_DATA,
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: ORDER_DETAILS_HIDE_ERROR_DATA,
        });
    }
    loader() {
        this.dispatch({
            type: ORDER_DETAILS_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: ORDER_DETAILS_STOP_LOADER,
        });
    }
}
export default OrderDetailsActions;
